import { render, staticRenderFns } from "./category-breadcrumb.vue?vue&type=template&id=340c620e&"
import script from "./category-breadcrumb.vue.ts?vue&type=script&lang=ts&"
export * from "./category-breadcrumb.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports